<template>
  <div>
    <b-modal
      id="edit-postfix"
      ref="modal"
      header-class="headerModal"
      centered
      :title="`${$t('EditPostfix')}: ${editPostfix?.name}`"
      hide-footer
      @close="onCancel"
    >
      <b-form>
        <b-form-group
          id="input-select-1"
          :label="$t('Name')"
          label-for="select-1"
        >
          <b-input
            v-model="$v.name.$model"
            :placeholder="$t('Write...')"
            :state="validateState('name')"
            aria-describedby="input-1-live-feedback"
            required
            @input="isPrefix(name)"
          />
          <p
            v-if="getIsPrefix == true && oldName != name"
            style="color: red;"
          >
            {{ $t("PrefixExists") }}
          </p>
          <p
            v-if="this.$v.$error"
            style="color: red;"
          >
            {{ $t("Required") }}
          </p>
        </b-form-group>
        <div class="buttonsEverywhere">
          <button
            type="button"
            variant="primary"
            class="buttonSubmit"
            style="margin-top: 10px;"
            :disabled="getIsPrefix == true && oldName != name"
            @click="onSubmit"
          >
            {{ $t('Submit') }}
          </button>
          <b-button
            type="button"
            variant="danger"
            class="buttonCancel"
            style="margin-right: 15px; margin-top: 10px; background: white; color: black; border-color: white;font-weight: 400;"

            @click="onCancel"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate';
import {
  required,
}
from 'vuelidate/lib/validators';

export default {
  mixins: [validationMixin],
  props: ['editPostfix'],
  data() {
    return {
      name: null,
      type: 'Postfix',
      settingsFixes: ['Postfix', 'Prefix'],
      orderNumberSettingsId: null,
      oldName: null,
    }
  },
  validations: {
    name: {
      required,
    },
  },
  computed: {
    ...mapGetters(['getIsPrefix']),
  },
  watch: {
    editPostfix(value) {
      if (value) {
        this.orderNumberSettingsId = value.id
        this.name = value.name
        this.oldName = value.name
      }
    },
  },
  mounted() {

  },
  methods: {
    ...mapActions(['loadIsPrefix', 'resetLoadIsPrefix']),
    isPrefix(value) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        this.loadIsPrefix({
          type: 'Postfix',
          name: value,
        })
      }, 500);
    },
    validateState(name) {
      const { $dirty, $error } = this.$v[name];
      return $dirty ? !$error : null;
    },
    onSubmit() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      const object = {
        name: this.name,
        type: this.type,
        orderNumberSettingsId: this.orderNumberSettingsId,
      }
      this.$emit('editPostfix', object)
      this.$refs.modal.hide()
      setTimeout(() => {
        this.resetForm()
      }, 10)
    },
    onCancel() {
      this.$refs.modal.hide()
      this.resetForm()
    },
    resetForm() {
      this.name = this.editPostfix.name
      this.type = 'Postfix'
      this.resetLoadIsPrefix()
      this.$nextTick(() => { this.$v.$reset() })
    },
  },
}
</script>

      <style lang="scss" scoped>
      </style>
